import ParentClass from './Parent.js';

class Global extends ParentClass {
  constructor() {
    super();
    const moduleClass = '';
    if(!super.runThisModule(moduleClass)) return;

    $('a.prevent-default').click((e) => e.preventDefault());

    $('.searchform').on('click', '.searchform--trigger', function(ev){
        const $searchForm = $(ev.delegateTarget);
        $searchForm.toggleClass('active');
        $searchForm.parent().addClass('position-relative');
    });
    $('.searchform').on('click', '.searchform--close-form', function(ev){
        const $searchForm = $(ev.delegateTarget);
        $searchForm.removeClass('active');
        $searchForm.parent().removeClass('position-relative');
    });

    $('.sub-menu--menu-item').on('click', '.sub-menu--toggle-dropdown-btn', function(ev){
        ev.stopPropagation();
        $(ev.delegateTarget).toggleClass('show');
    });

    $('.interactive-offerings--col').on('click', function(){
      const columnurl    = $(this).find('a').attr('href');
      const columntarget = $(this).find('a').attr('target');

      if ('' !== columntarget) {
        window.open(columnurl, columntarget);
      } else {
        window.location.href = columnurl;
      }
    });

    // Adds a class to #main-nav-container when the mobile menu opens
    $(document).on("click.bs.collapse.data-api", '[data-toggle="collapse"]', function (ev) {
      const navbarToggler = $('.navbar .navbar-toggler');
      if( navbarToggler[0].contains(ev.target) ){
        $('.navbar').toggleClass('navbar-mobile-nav-open');
        $('body').toggleClass('mobile-nav-open');
      }
    });

    // recreate hover behavior we had to remove from css in order to override bootstrap show/hide behavior
    $(document).on('mouseover mouseout', $('.expanded-dropdown').find('>.nav-link'), function(e) {
      let myParent = $('.expanded-dropdown.nav-item');
      let thisEl = $('.expanded-dropdown').find('>.nav-link');
      let dropdown = myParent.find('ul.dropdown-menu');

      if ($('#searchform').css('display') == 'block') {
        setTimeout(function () {
          let isHover = (
              myParent.is(':hover') ||
              thisEl.is(':hover') ||
              dropdown.is(':hover')
          );
          if (isHover) {
            myParent.addClass('show');
            dropdown.addClass('show');
          } else {
            myParent.removeClass('show');
            dropdown.removeClass('show');
          }
        }, 10);
      }
    });

    // override bootstrap dropdown click behavior to hide expanded menu immediately on click
    $(document).on('click', $('.expanded-dropdown').find('>.nav-link'), function(e) {
      let myParent = $('.expanded-dropdown.nav-item');
      let dropdown = myParent.find('ul.dropdown-menu');

      if ($('#searchform').css('display') == 'block') {
        setTimeout(function () {
          myParent.removeClass('show');
          dropdown.removeClass('show');
        }, 10);
      }
    });

    this.initHero();
    this.initInteractiveColumns();
    this.initAwards();
    this.initClientTestimonials();
    this.initAjaxArticles();
    this.initPartnersSlider();
  }

  initHero() {
    const mainSlider    = $('.main-slider__images');
    const contentSlider = $('.main-slider__content');
    const slickPrev     = $('.main-slider__arrows .slick-prev');
    const slickNext     = $('.main-slider__arrows .slick-next');

    if (mainSlider.length > 0) {
      $(document).ready(function() {
        mainSlider.not('.slick-initialized').slick({
          rows: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          asNavFor: contentSlider,
          prevArrow: slickPrev,
          nextArrow: slickNext
        });

        contentSlider.not('.slick-initialized').slick({
          rows: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          asNavFor: mainSlider,
          arrows: false,
          dots: false,
          fade: true,
          cssEase: 'linear',
        });
      });
    }
  }

  initAwards() {
    const awardsSlider = $('.awards-slider__wrapper');

    if (awardsSlider.length > 0) {
      $(document).ready(function() {
        awardsSlider.not('.slick-initialized').slick({
          rows: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          adaptiveHeight: true
        });
      });
    }
  }

  initPartnersSlider() {
  	const self = this;
    const partnersSlider = $('.featured-partners-slider__wrapper');
    const numPartners    = $('.featured-partners-slider__wrapper .partner').length;
    const partnersSliderSettings = {
          rows: 0,
          arrows: true,
          dots: false,
          adaptiveHeight: true,
          slidesToShow: 4,
	        slidesToScroll: 1,
	        infinite: true,
          responsive: [
				    {
				      breakpoint: 1200,
				      settings: {
				        slidesToShow: 2,
				      }
				    },
				    {
				      breakpoint: 768,
				      settings: {
				        slidesToShow: 1,
				      }
				    }
				  ]
        };
    var resizeTimer;


    if (partnersSlider.length > 0) {

      $(document).ready(function() {
      	if (($(window).width() < 1200) || (numPartners > 4)) {
	        partnersSlider.not('.slick-initialized').slick(partnersSliderSettings).on('setPosition', function (event, slick) {
	        	var slides = $('.featured-partners-slider__wrapper .partner');
	        	var height = slick.$slideTrack.height() + 'px';
	        	slides.each(function(index, el) {
	        		$(this).height(height);
	        	});
					});
      	}
      });

	    $(window).resize(function(e) {
    	 	clearTimeout(resizeTimer);
		  	resizeTimer = setTimeout(function() {
		    	if (($(window).width() > 1200) && (numPartners < 5)) {
		    		partnersSlider.not('.slick-initialized').slick('unslick');
		    	} else {
		    		partnersSlider.not('.slick-initialized').slick(partnersSliderSettings).on('setPosition', function (event, slick) {
		    			var slides = $('.featured-partners-slider__wrapper .partner');
		        	var height = slick.$slideTrack.height() + 'px';
		        	slides.each(function(index, el) {
		        		$(this).height(height);
		        	});
						});
		    	}
			  }, 100);
	    });
    }

  }

  initClientTestimonials() {
    const testimonialSlider = $('.client-testimonials__slider');

    if (testimonialSlider.length > 0) {
      $(document).ready(function() {
        testimonialSlider.not('.slick-initialized').slick({
          rows: 0,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
        });
      });
    }
  }

  initInteractiveColumns() {
    const wrapper       = $('.interactive-columns');
    const columns       = $('.interactive-columns .interactive-columns__col');
    const accrdnBreakpt = 1200;
    var resizeTimer;

    if (wrapper.length > 0) {
      $(window).resize(function() {
        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
          if ($(window).width() > accrdnBreakpt) {
            var bckg = $(columns[0]).attr('data-bckg');
            wrapper.css('background-image', 'url(' + bckg + ')');

            columns.each(function(index, el) {
              var toggle      = $(this).find('.toggle');
              var description = $(this).find('.description');

              toggle.stop().removeClass('active');
              description.stop().removeAttr('style').removeClass('active');
            });
          } else {
            wrapper.removeAttr('style');
          }
        }, 250);
      });

      $(document).ready(function() {
        if ($(window).width() > accrdnBreakpt) {
          var bckg = $(columns[0]).attr('data-bckg');
          wrapper.css('background-image', 'url(' + bckg + ')');
        }

        // hack for css box sizing issue between platforms
        if ($(window).width() > 1380) {
          var os = navigator.platform;
          if (os.includes('Win')) {
            $('.column').css('max-width', '460px');
            $('.column').css('width', '460px');
          }
        }
      });

      columns.each(function(index, el) {
        var bckg         = $(this).attr('data-bckg');
        var columnurl    = $(this).find('.link').attr('href');
        var columntarget = $(this).find('.link').attr('target');

        $(this).hover(function() {
          if ($(window).width() >= accrdnBreakpt) {
            wrapper.css('background-image', 'url(' + bckg + ')');
          }
        });

        $(this).on('click', function() {
          if ('' !== columntarget) {
            window.open(columnurl, columntarget);
          } else {
            window.location.href = columnurl;
          }
        });
      });
    }
  }

  initAjaxArticles() {
  	const container      = $('.all-ajax-articles');
    const articleWrapper = $('.all-ajax-articles .articles');
    const typeFilter     = $('ul.article-filter li a');
    const loadMore       = $('.load-more');
    const maxLoad        = 9;
    const totalArticles  = $('.all-ajax-articles .article-wrapper.all-type');

    var visibleArticles;
    var selectedArticles;
    var selectedType = 'all';

    if (container.length > 0) {

      // Updated visible articles and load more functionality on change
      $(document).on('article-refresh', function(e) {
        visibleArticles = $('.all-ajax-articles .article-wrapper:visible');
        if (selectedArticles.length > visibleArticles.length) {
          loadMore.show(0);
        } else {
          loadMore.hide(0);
        }
      });

      // Load more functionality
      loadMore.click(function(e) {
        e.preventDefault();
        selectedArticles.slice(visibleArticles.length, (visibleArticles.length + maxLoad)).show(0);
        $(document).trigger('article-refresh');
      });

      // Filter functionality
      typeFilter.click(function(e) {
        e.preventDefault();
        totalArticles.hide(0);

        // Get selected articles, visible articles and selected filter.
        selectedType     = $(this).attr('data-type');
        selectedArticles = $('.all-ajax-articles .article-wrapper.' + selectedType + '-type');

        // Change active filter
        typeFilter.not($(this)).each(function(i, e) {
          $(this).removeClass('active');
        });

        $(this).addClass('active');

        selectedArticles.slice(0, maxLoad).show(0);

        $(document).trigger('article-refresh');
      });

      // Initial load, hide all but max load articles
      totalArticles.hide(0);
      selectedArticles = $('.all-ajax-articles .article-wrapper.' + selectedType + '-type');
      selectedArticles.slice(0, maxLoad).show(0);
      $(document).trigger('article-refresh');
  	}
  }

}

jQuery(document).ready(function() {
	new Global();
});



// WEBPACK FOOTER //
// ./wp-content/themes/variscale/library/js/classes/Global.js